module.exports = __webpack_public_path__ + "static/media/tal-g.cfc0ac4b.svg";